export const LOCAL_STORAGE_401_OCCURRENCES_COUNT_KEY = "401_occurrences_count";
export const LOCAL_STORAGE_GOOGLE_ACCESS_TOKEN_KEY =
  "GOOGLE_BUSINESS_ACCESS_TOKEN";
export const LOCAL_STORAGE_NOTIFICATION_SOUND_ENABLED_KEY =
  "notification_sound_enabled";
export const LOCAL_STORAGE_SELECTED_MERCHANT_ID_KEY = "fuzey:merchant:id";

export interface GoogleAccessTokenStorageEntry {
  token: string;
  expiry: number;
}

export class LocalStorage {
  /**
   * Drop the last-selected merchant. Called when a session ends: the id is only
   * meaningful for the agent who chose it, and a value naming a merchant the
   * next agent cannot access makes the private routes request it anyway, before
   * `/agents/me` has said otherwise. Leaving it behind is what made a single bad
   * value survive every logout and re-break the following login.
   */
  static clearSelectedMerchantId(): void {
    localStorage.removeItem(LOCAL_STORAGE_SELECTED_MERCHANT_ID_KEY);
  }

  static upsert401Occurrences(): number {
    const occurrences =
      parseInt(
        localStorage.getItem(LOCAL_STORAGE_401_OCCURRENCES_COUNT_KEY) || "0",
        10
      ) + 1;

    localStorage.setItem(
      LOCAL_STORAGE_401_OCCURRENCES_COUNT_KEY,
      occurrences.toString()
    );

    return occurrences;
  }

  static getValidGoogleAccessToken(): string | null {
    const accessToken = localStorage.getItem(
      LOCAL_STORAGE_GOOGLE_ACCESS_TOKEN_KEY
    );
    // if the item doesn't exist, return null

    if (!accessToken) {
      return null;
    }
    const tokenObj: GoogleAccessTokenStorageEntry = JSON.parse(accessToken);
    const now = Date.now();
    // compare the expiry time of the item with the current time

    if (now >= tokenObj.expiry) {
      // If the item is expired, delete the item from storage
      // and return null
      localStorage.removeItem(LOCAL_STORAGE_GOOGLE_ACCESS_TOKEN_KEY);

      return null;
    }

    return tokenObj.token;
  }

  static isNotificationSoundEnabled(): boolean {
    return (
      localStorage.getItem(LOCAL_STORAGE_NOTIFICATION_SOUND_ENABLED_KEY) ===
      "true"
    );
  }

  static setNotificationSoundEnabled(enabled: boolean): void {
    localStorage.setItem(
      LOCAL_STORAGE_NOTIFICATION_SOUND_ENABLED_KEY,
      enabled ? "true" : "false"
    );
  }

  static setGoogleTokenWithExpiry(token: string, ttl: number) {
    const now = Date.now();

    // `item` is an object which contains the original value
    // as well as the time when it's supposed to expire

    const item: GoogleAccessTokenStorageEntry = {
      token,
      expiry: now + Number(ttl * 1000),
    };

    localStorage.setItem(
      LOCAL_STORAGE_GOOGLE_ACCESS_TOKEN_KEY,
      JSON.stringify(item)
    );
  }
}
